import type { ModalActionHandler } from './modalActionTypes';
import { unassignJob } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const fireHunterAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.jobs.hunters <= 0) return false;
    if (!unassignJob(settlement, 'hunters')) return false;
    settlement.production.hunt.progress.pop();
    return true;
};
